var render = function render(){var _vm=this,_c=_vm._self._c;return (_vm.unreadCount)?_c('span',{staticClass:"nav-unread"}):_vm._e()
}
var staticRenderFns = []

export { render, staticRenderFns }